import { MOJE_GWO_LINK, LOGOUT_LINK, } from 'common/constants';

export type MenuItemType = {
    text: string,
    url: string,
    method?: string,
};

const menuItems = [
    {
        text: 'moje GWO',
        url: MOJE_GWO_LINK,
    },
    {
        text: 'wyloguj',
        url: LOGOUT_LINK,
        method: 'replace',
    },
];

export default menuItems;
